import React from 'react';
import { Card, Descriptions, Tag } from 'antd';
import {
  getStatusColor,
  getStatusLabel,
  getProductiveUnitTypeLabel,
  formatDate,
} from './cycleDetailHelpers';

export interface CycleDetailInfoCardProps {
  cycle: any;
  isMobile?: boolean;
}

export const CycleDetailInfoCard: React.FC<CycleDetailInfoCardProps> = ({
  cycle,
  isMobile = false,
}) => {
  return (
    <Card
      style={{ marginBottom: isMobile ? '16px' : '24px' }}
      bodyStyle={{ padding: isMobile ? '12px 10px' : '20px' }}
    >
      <Descriptions
        bordered
        size="small"
        column={{ xxl: 4, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}
      >
        <Descriptions.Item label="Estado">
          <Tag color={getStatusColor(cycle.status)}>
            {getStatusLabel(cycle.status)}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Categoría">
          {cycle.cycle_category === 'FINITE_TRANSFORMATION' ? 'Finita' : 'Recurrente'}
        </Descriptions.Item>
        <Descriptions.Item label="Tipo">
          {getProductiveUnitTypeLabel(cycle.productive_unit_type)}
        </Descriptions.Item>
        <Descriptions.Item label="Capacidad / Tamaño Actual">
          <b>
            {cycle.current_quantity ?? cycle.initial_quantity ?? 0}{' '}
            {cycle.unit_of_measure}
          </b>
        </Descriptions.Item>
        <Descriptions.Item label="Fecha Inicio">
          {formatDate(cycle.start_date)}
        </Descriptions.Item>
        {cycle.actual_end_date && (
          <Descriptions.Item label="Fecha Fin">
            {formatDate(cycle.actual_end_date)}
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Motivo de Cierre">
          {cycle.close_reason || '-'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};
